import * as React from "react";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";

import TechStackList from "./techstack-list";

/**
 * Renders the techstack section
 * Shows the techstack list
 */
const Techstack = () => {
  const headingRef = React.useRef<HTMLHeadingElement>(null);
  const subHeadingRef = React.useRef<HTMLHeadingElement>(null);

  useGSAP(() => {
    const refs = [headingRef, subHeadingRef];

    refs.forEach((ref, index) => {
      gsap.fromTo(
        ref.current,
        { y: "100%" },
        {
          y: 0,
          duration: 1.5,
          delay: 0.075 * index,
          ease: "power4",
          scrollTrigger: {
            trigger: ref.current,
            start: "top 85%",
            end: "bottom center",
          },
        }
      );
    });
  }, []);

  const containerStyles = `
    2xl:max-w-8xl 3xl:max-w-9xl 4xl:max-w-10xl 5xl:max-w-11xl relative z-20 mx-auto mt-20 flex w-full max-w-full cursor-default flex-col items-center justify-center gap-y-16 sm:max-w-[40rem] md:max-w-[50rem] lg:max-w-[63rem] xl:max-w-[75rem]
  `;

  return (
    <section className={containerStyles}>
      <div className="flex w-full flex-col items-center justify-center gap-y-6">
        <div className="xs:py-3 xs:h-auto h-14 overflow-hidden text-center">
          <h1
            className="work-heading leading-[1.2] 2xl:leading-[1.3]"
            ref={headingRef}
          >
            Current Stack.
          </h1>
        </div>
        <div className="hero-paragraph flex w-full items-center justify-center overflow-hidden px-5 sm:px-10">
          <p ref={subHeadingRef} className="hero-paragraph-text text-center">
            A small list of cool things I use to construct my projects.
          </p>
        </div>
      </div>
      <TechStackList />
    </section>
  );
};

export default Techstack;
